import React, { useContext, useEffect } from 'react';

import { Context, listenerTypes } from './context';

/**
 * @typedef {import('./global-event-listener-types.d.ts').GlobalEventListenerComponent} GlobalEventListenerComponent
 * @typedef {import('./global-event-listener-types.d.ts').ListenerTypes} ListenerTypes
 */

/**
 * @type {GlobalEventListenerComponent}
 */
export const GlobalEventListener = ({ children, ...props }) => {
  const { subscribe, isDefaultValue } = useContext(Context);

  if (isDefaultValue) {
    throw new Error('GlobalEventListener is intended to be used inside of a GlobalEventListenerRoot, but none was found.');
  }

  Object.keys(props).forEach((prop) => {
    if (prop.indexOf('on') === 0 && listenerTypes.indexOf(/** @type {ListenerTypes} */ (prop)) === -1) {
      throw new Error(
        `${prop} is not currently supported in the GlobalEventListener component, please add it to the list if you want to add support for it.`,
      );
    }
  });

  listenerTypes.forEach((listenerType) => {
    // TODO: This looks kinda fishy and breaks some hooks rules.
    // eslint-disable-next-line
    useEffect(() => {
      if (typeof props[listenerType] === 'function') {
        return subscribe(listenerType, props[listenerType]);
      }
      // eslint-disable-next-line
    }, [props[listenerType], subscribe]);
  });

  return React.Children.only(children);
};
